import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import HintButton from 'components/Common/Buttons/HintButton';

const SupportingDocumentCuresComponent = ({
  modalId,
  supportingDocuments,
  onModalOpen,
  onModalClose,
  activeModal
}) => {
  const [showModal, setShowModal] = useState(false);
  const buttonBackground = '#9e9e9e';
  const buttonBackgroundPressed = '#893c80';
  const buttonBackgroundHovered = '#616161';
  const iconColour = '#fff';

  const onToggle = () => {
    setShowModal(!showModal);
    onModalOpen(modalId);
  };

  const onClose = () => {
    setShowModal(false);
    onModalClose();
  };

  useEffect(() => {
    if (activeModal !== modalId) {
      setShowModal(false);
    }
  }, [activeModal]);

  const modalVisible = (activeModal === modalId) && showModal;

  const sortedSupportingDocuments = [...supportingDocuments].sort((a, b) => {
    if (a === 'Other document type not listed above') return 1;
    if (b === 'Other document type not listed above') return -1;

    return a.localeCompare(b);
  });

  return (
    <div className="supporting-docs-wrapper">
      <HintButton
        id="supporting-docs-modal-btn"
        hintType="hint"
        active={ modalVisible }
        buttonBackground={ buttonBackground }
        buttonBackgroundPressed={ buttonBackgroundPressed }
        buttonBackgroundHovered={ buttonBackgroundHovered }
        iconColour={ iconColour }
        iconColourPressed={ iconColour }
        onClick={
          () => { onToggle(); }
        }
      />
      { modalVisible && <div className="columns supporting-docs-modal" tabIndex={ -1 }>
        <button type="button" className="btn btn-clear float-right" onClick={ () => onClose() } />
        <div className="col-12 py-1">
          <h3>Supporting Documents that clear this:</h3>
          <ul id="supporting-docs-cures-list">
            { sortedSupportingDocuments.map((element, index) => <li key={ `${ modalId }-supporting-docs-modal-li-${ index + 1 }` }><em>{ element }</em></li>) }
          </ul>
        </div>
        </div> }
    </div>
  );
};

SupportingDocumentCuresComponent.propTypes = {
  modalId: PropTypes.string.isRequired,
  supportingDocuments: PropTypes.arrayOf(PropTypes.string).isRequired,
  onModalOpen: PropTypes.func,
  onModalClose: PropTypes.func,
  activeModal: PropTypes.string
};

SupportingDocumentCuresComponent.defaultProps = {
  onModalOpen: null,
  onModalClose: null,
  activeModal: null
};

export default SupportingDocumentCuresComponent;
